import { render, staticRenderFns } from "./BrandColors.vue?vue&type=template&id=207fbe72&scoped=true&"
import script from "./BrandColors.vue?vue&type=script&lang=js&"
export * from "./BrandColors.vue?vue&type=script&lang=js&"
import style0 from "./BrandColors.vue?vue&type=style&index=0&id=207fbe72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207fbe72",
  null
  
)

export default component.exports